import { useState } from "react";
import { Modal } from "react-bootstrap";
import { deleteProjectVendorById } from "../../api/projects";
import { useProjectVendorHooks } from "../../utils/project/VendorProjectUtils";
import AlertBox from "../AlertBox";

export default function ModalProjectVendorDelete({ show, id, onClose, onSuccess }) {
  const vendor = useProjectVendorHooks({id});

  const [alert, setAlert] = useState({show: false, message: '', type: ''});
  let [loading, setLoading] = useState(false);

  const handleClose = () => {
    if (!loading) {
      setAlert({show: false, message: '', type: ''});
      onClose();
    }
  }

  const onDeleteVendor = async () => {
    setLoading(true);
    try {
      let response = await deleteProjectVendorById(id);
      onSuccess(response.data.message);
      handleClose();
    } catch (error) {
      let message = ""
      if (error.response) {
        let { data } =  error.response;
        message = data.message;
      } else {
        message = "Something Error Happened";
      }

      setAlert({show: true, message, type: 'danger'})
    }

    setLoading(false);
  }

  return(
    <Modal show={show} onHide={() => handleClose()}>
      <Modal.Header closeButton>
        <Modal.Title>Hapus Data Vendor - "{vendor.data.vendor?.name}"</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <AlertBox {...alert} setAlert={setAlert} />
        <h5 className="text-gray-800">Apakah anda yakin akan menghapus vendor "{vendor.data.vendor?.name}"?</h5>
      </Modal.Body>
      <Modal.Footer>
        <button className="btn btn-default" onClick={() => handleClose()}>Tidak</button>
        <button className="btn btn-danger" onClick={() => onDeleteVendor()} disabled={loading}>{loading ? 'Menghapus ...' : 'Ya'}</button>
      </Modal.Footer>
    </Modal>
  )
}